import { Platform } from 'react-native';
const toggle = {
    on: '#B368FF',
    off: '#6E719180',
};
const control = {
    hoverOnLight: '#362E4C66',
    hoverOnDark: '#362E4C99',
};
const borders = {
    logoStroke: '#393349',
    divider: '#393349',
    divider2: '#393349',
    strongDivider: '#393349',
    iconStroke: '#393349',
    buttonStroke: '#E9E8EA',
};
const text = {
    black: '#000000',
    white: '#FFFFFFE6',
    whiteOnColor: '#FFFFFF',
    whitePlaceholder: '#FFFFFFB3',
    primary: '#FFFFFFE6',
    onPrimary: '#17102A',
    secondary: '#FFFFFFCC',
    tertiary: '#FFFFFFCC',
    brand: '#B56CFF',
    textOnBrand: '#FFFFFFE6',
    textOnBrandLight: '#FFFFFF',
    income: '#7ED1FC',
    negative: '#FF7D9C',
    positive: '#5CD4CD',
    feed: '#FF93E4',
    placeholder: '#FFFFFF99',
    selection: '#B56CFF80',
    debt: '#FFFFFFCC',
    investment: '#2EE3B6',
    textOnDisabledButton: '#FFFFFF4D',
    statusPositive: '#5CD4CD',
    statusNegative: '#FF7D9C',
    statusInformational: '#EC9E8F',
    statusOffline: '#D3D2D7',
};
const background = {
    contrast: '#974EE1',
    dark: '#17102A',
    light: '#17102A',
    transparent: '#FFFFFF33',
    transparentDark: '#17102A66',
    brand: '#17102A',
    brandMedium: '#231C35',
    secondary: '#FFFFFF33',
    frosted: '#231C35',
    brandLight: '#372854',
    underlay: '#FFFFFF04',
    logo: '#FFFFFF',
    black: '#000',
    fullTransparent: 'rgba(0, 0, 0, 0)',
    artwork: '#F8F9FB',
    verticalTab: '#231C35',
    plusLight: '#FFCA7626',
    proLight: '#1CDCE51A',
    ultimateLight: '#B368FF26',
};
const cards = {
    onDark: '#231C35',
    onLight: '#231C35',
    transparentOnDark: '#393349',
    brand: '#17102A',
};
const buttons = {
    primary: '#E9E8EB',
    primaryOnBrand: '#E9E8EB',
    primaryOnBrandDisabled: '#FFFFFF80',
    secondary: '#393349',
    brand: '#B56CFF',
    brandLight: '#B56CFF',
    brandGroup: '#393349',
    frosted: '#FFFFFF33',
    onColor: '#393349',
    blackAbsolutelyOnBrand: '#FFF',
    negativeLight: '#FF7D9C1A',
    negativePrimary: '#FF7D9C',
    brandDisabled: '#462C6A',
    white: '#FFFFFF',
    brandHover: '#7F49B6',
    brandLightHover: '#7F49B6',
    brandGroupHover: '#2B2340',
};
const elements = {
    black: '#17102A',
    white: '#FFFFFFE6',
    floatingWhite: '#FFFFF6',
    brandLight: '#B56CFF',
    brandMedium: '#57397E',
    primary: '#FFFFFFE6',
    secondary: '#FFFFFFE6',
    secondaryFill: '#FFFFFF',
    secondaryLight: '#FFFFFFCC',
    secondaryLighter: '#656172',
    secondaryTransparent: '#FFFFFF33',
    secondaryTransparentFill: '#494356',
    secondaryLightTransparent: '#FFFFFF4D',
    onLight: '#393349',
    brand: '#B56CFF',
    feed: '#F692FF',
    positive: '#5CD4CD',
    positiveLight: '#5CD4CD12',
    negative: '#FF7D9C',
    income: '#7ED1FC',
    green: '#5CD4CD',
    primaryOnModal: '#2E2E2E',
    brandOnModal: '#281E36',
    statusPositive: '#5CD4CD',
    statusPositiveLight: '#5CD4CD12',
    statusNegative: '#FF7D9C',
    statusNegativeLight: '#FF7D9C1A',
    statusInformational: '#FFA777',
    statusInformationalLight: '#FFA77714',
    statusOffline: '#D3D2D7',
    statusOfflineLight: '#D3D2D71A',
    frostedOnBrand: '#B399FF',
    investment: '#2EE3B6',
    save: '#A07FFF',
};
const status = {
    negative: '#FF7D9C',
    negativeLight: '#FF7D9C1A',
    positive: '#65C5BF',
    positiveLight: '#63DDCF17',
    informational: '#EC9E8F',
    informationalLight: '#EC9E8F12',
    offline: '#FFFFFFCC',
    offlineLight: '#D3D2D714',
};
const gradients = {
    white: {
        colors: ['#FFFFFFE6', '#FFFFFFE6'],
        locations: [0, 1],
        useAngle: true,
        angle: 90,
    },
    metallic: {
        colors: ['#FFFFFF00', '#FFFFFFFF', '#FFFFFF00'],
        locations: [0, 0.5, 1],
        useAngle: true,
        angle: 90,
    },
    ultimate: {
        colors: ['#B368FF', '#B368FF'],
        locations: [0, 1],
        useAngle: true,
        angle: 90,
    },
    pro: {
        colors: ['#5ADFE6', '#5ADFE6'],
        locations: [0, 1],
        useAngle: true,
        angle: 90,
    },
    plus: {
        colors: ['#FFD99E', '#FFD99E'],
        locations: [0, 1],
        useAngle: true,
        angle: 90,
    },
    darkPurple: {
        colors: ['#A07FFF', '#A07FFF'],
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    lightPurple: {
        colors: ['#D490F8', '#D490F8'],
        locations: [0, 1],
        useAngle: true,
        angle: 90,
    },
    darkPink: {
        colors: ['#F692FF', '#F692FF'],
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    lightPink: {
        colors: ['#FCA1E5', '#FCA1E5'],
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    deepPink: {
        colors: ['#FF87BF', '#FF87BF'],
        colorVariant: {
            light: '#FF90C4',
            dark: '#FF75B6',
        },
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    apricot: {
        colors: ['#FFA7A5', '#FFA7A5'],
        colorVariant: {
            light: '#FFBAB9',
            dark: '#FF6766',
        },
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    orange: {
        colors: ['#FFB8A7', '#FFB8A7'],
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    peach: {
        colors: ['#FFBAC5', '#FFBAC5'],
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    yellow: {
        colors: ['#FFE49D', '#FFE49D'],
        colorVariant: {
            light: '#FFE046',
            dark: '#F9B800',
        },
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    lime: {
        colors: ['#D5FF82', '#D5FF82'],
        colorVariant: {
            light: '#D8FF8B',
            dark: '#B2ED3F',
        },
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    forest: {
        colors: ['#6FE5B4', '#6FE5B4'],
        colorVariant: {
            light: '#90F2C9',
            dark: '#52E5A8',
        },
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    turquoise: {
        colors: ['#6AF2F0', '#6AF2F0'],
        locations: [0, 1],
        useAngle: true,
        angle: 90,
    },
    skyBlue: {
        colors: ['#7FDEFF', '#7FDEFF'],
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    headerGradientCards: {
        colors: ['#17102A', '#17102A'],
        locations: [0, 1],
        useAngle: true,
        angle: 90,
    },
    brandGradient: {
        colors: ['#17102A', '#17102A'],
        locations: [0, 1],
        useAngle: true,
        angle: 90,
    },
    negativeCards: {
        colors: ['#231C35', '#231C35'],
        locations: [0, 1],
        useAngle: true,
        angle: 180,
    },
    brandCards: {
        colors: ['#231C35', '#231C35'],
        locations: [0, 1],
        useAngle: true,
        angle: 90,
    },
    time: {
        colors: ['#86F265', '#B2ED3F'],
        locations: [0, 1],
        useAngle: true,
        angle: 90,
    },
};
const categories = {
    bills: '#FFB8A7',
    business: '#FCA1E5',
    cash: '#FFE49D',
    charity: '#7FDEFF',
    custom: '#9E9DBC',
    eatOut: '#4FE8D6',
    education: '#FFA9A9',
    entertainment: '#C078FF',
    family: '#5CDA91',
    general: '#FF87BF',
    groceries: '#46E4E7',
    personalCare: '#FF6BA0',
    holidays: '#6D8FFF',
    housing: '#B6E478',
    income: elements.income,
    investment: text.investment,
    shopping: '#A07FFF',
    transport: '#FFB0CB',
    transfer: elements.secondary,
};
const sectors = {
    tech: '#FF87BF',
    esg: '#5CDA91',
    bonds: '#FF9191',
    consumerGoods: '#A07FFF',
    healthcare: '#FF6BA0',
    defense: '#7FDEFF',
    commodities: '#FFE49D',
    realEstate: '#B6E478',
    sharia: '#6D8FFF',
};
const night = {
    toggle,
    borders,
    control,
    text,
    background,
    cards,
    buttons,
    elements,
    status,
    gradients,
    categories,
    sectors,
    shadows: {
        chart: '#FFFFFF33',
        androidShadowGradientStart: 'rgba(0,0,0,0)',
        androidShadowGradientEnd: 'rgba(0,0,0,0)',
        rewardPreview: 'transparent',
        tabBar: {},
        floatingButton: {},
        floatingSquircle: {
            ...Platform.select({
                android: {
                    elevation: 0,
                },
            }),
        },
        logoShadow: {},
        logoShadowInner: {},
        logoShadowInnerLight: {},
        receipt: {},
        fakeReceipt: {},
        cardLight: {},
        card: {
            shadowColor: 'transparent',
        },
        extendedHeader: {},
        cardMedium: {},
        cardLarge: {},
        badge: {},
        headerAnimatedShadow: {},
        headerAnimatedShadowWithElevation: {},
        squircle: {},
        stockScreenCTA: {},
        budgetingChartShadow: {},
        recommendationCard: {},
        subscriptionsLogo: {},
        subscriptionsLogoBolder: {},
        reportGiphyCard: {},
        reportImageCard: {},
        graphBar: {},
        statusIconContainer: {},
        webFloatingCard: {
            elevation: 2,
            shadowColor: '#133068',
            shadowOpacity: 0.01,
            shadowOffset: { width: 1, height: 1 },
            shadowRadius: 10,
        },
    },
    tabBar: {
        default: '#FFFFFFE6',
    },
    invest: {
        header: elements.white,
    },
    statusBar: {
        regular: 'light-content',
    },
};
export default night;
